"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const fs = __importStar(require("fs"));
const yaml = __importStar(require("js-yaml"));
const core = __importStar(require("@actions/core"));
const exec = __importStar(require("@actions/exec"));
const actionsToolkit = __importStar(require("@docker/actions-toolkit"));
const buildx_1 = require("@docker/actions-toolkit/lib/buildx/buildx");
const docker_1 = require("@docker/actions-toolkit/lib/docker");
const toolkit_1 = require("@docker/actions-toolkit/lib/toolkit");
const util_1 = require("@docker/actions-toolkit/lib/util");
const context = __importStar(require("./context"));
const stateHelper = __importStar(require("./state-helper"));
actionsToolkit.run(
// main
() => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const inputs = yield context.getInputs();
    const toolkit = new toolkit_1.Toolkit();
    const standalone = yield toolkit.buildx.isStandalone();
    stateHelper.setStandalone(standalone);
    yield core.group(`Docker info`, () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield docker_1.Docker.printVersion();
            yield docker_1.Docker.printInfo();
        }
        catch (e) {
            core.info(e.message);
        }
    }));
    let toolPath;
    if (util_1.Util.isValidUrl(inputs.version)) {
        if (standalone) {
            throw new Error(`Cannot build from source without the Docker CLI`);
        }
        yield core.group(`Build buildx from source`, () => __awaiter(void 0, void 0, void 0, function* () {
            toolPath = yield toolkit.buildxInstall.build(inputs.version);
        }));
    }
    else if (!(yield toolkit.buildx.isAvailable()) || inputs.version) {
        yield core.group(`Download buildx from GitHub Releases`, () => __awaiter(void 0, void 0, void 0, function* () {
            toolPath = yield toolkit.buildxInstall.download(inputs.version || 'latest');
        }));
    }
    if (toolPath) {
        yield core.group(`Install buildx`, () => __awaiter(void 0, void 0, void 0, function* () {
            if (standalone) {
                yield toolkit.buildxInstall.installStandalone(toolPath);
            }
            else {
                yield toolkit.buildxInstall.installPlugin(toolPath);
            }
        }));
    }
    yield core.group(`Buildx version`, () => __awaiter(void 0, void 0, void 0, function* () {
        yield toolkit.buildx.printVersion();
    }));
    core.setOutput('name', inputs.name);
    stateHelper.setBuilderName(inputs.name);
    fs.mkdirSync(buildx_1.Buildx.certsDir, { recursive: true });
    stateHelper.setCertsDir(buildx_1.Buildx.certsDir);
    if (inputs.driver !== 'docker') {
        yield core.group(`Creating a new builder instance`, () => __awaiter(void 0, void 0, void 0, function* () {
            const certsDriverOpts = buildx_1.Buildx.resolveCertsDriverOpts(inputs.driver, inputs.endpoint, {
                cacert: process.env[`${context.builderNodeEnvPrefix}_0_AUTH_TLS_CACERT`],
                cert: process.env[`${context.builderNodeEnvPrefix}_0_AUTH_TLS_CERT`],
                key: process.env[`${context.builderNodeEnvPrefix}_0_AUTH_TLS_KEY`]
            });
            if (certsDriverOpts.length > 0) {
                inputs.driverOpts = [...inputs.driverOpts, ...certsDriverOpts];
            }
            const createCmd = yield toolkit.buildx.getCommand(yield context.getCreateArgs(inputs, toolkit));
            yield exec.exec(createCmd.command, createCmd.args);
        }));
    }
    if (inputs.append) {
        yield core.group(`Appending node(s) to builder`, () => __awaiter(void 0, void 0, void 0, function* () {
            let nodeIndex = 1;
            const nodes = yaml.load(inputs.append);
            for (const node of nodes) {
                const certsDriverOpts = buildx_1.Buildx.resolveCertsDriverOpts(inputs.driver, `${node.endpoint}`, {
                    cacert: process.env[`${context.builderNodeEnvPrefix}_${nodeIndex}_AUTH_TLS_CACERT`],
                    cert: process.env[`${context.builderNodeEnvPrefix}_${nodeIndex}_AUTH_TLS_CERT`],
                    key: process.env[`${context.builderNodeEnvPrefix}_${nodeIndex}_AUTH_TLS_KEY`]
                });
                if (certsDriverOpts.length > 0) {
                    node['driver-opts'] = [...(node['driver-opts'] || []), ...certsDriverOpts];
                }
                const appendCmd = yield toolkit.buildx.getCommand(yield context.getAppendArgs(inputs, node, toolkit));
                yield exec.exec(appendCmd.command, appendCmd.args);
                nodeIndex++;
            }
        }));
    }
    yield core.group(`Booting builder`, () => __awaiter(void 0, void 0, void 0, function* () {
        const inspectCmd = yield toolkit.buildx.getCommand(yield context.getInspectArgs(inputs, toolkit));
        yield exec.exec(inspectCmd.command, inspectCmd.args);
    }));
    if (inputs.install) {
        if (standalone) {
            throw new Error(`Cannot set buildx as default builder without the Docker CLI`);
        }
        yield core.group(`Setting buildx as default builder`, () => __awaiter(void 0, void 0, void 0, function* () {
            const installCmd = yield toolkit.buildx.getCommand(['install']);
            yield exec.exec(installCmd.command, installCmd.args);
        }));
    }
    const builderInspect = yield toolkit.builder.inspect(inputs.name);
    const firstNode = builderInspect.nodes[0];
    yield core.group(`Inspect builder`, () => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const reducedPlatforms = [];
        for (const node of builderInspect.nodes) {
            for (const platform of ((_b = node.platforms) === null || _b === void 0 ? void 0 : _b.split(',')) || []) {
                if (reducedPlatforms.indexOf(platform) > -1) {
                    continue;
                }
                reducedPlatforms.push(platform);
            }
        }
        core.info(JSON.stringify(builderInspect, undefined, 2));
        core.setOutput('driver', builderInspect.driver);
        core.setOutput('platforms', reducedPlatforms.join(','));
        core.setOutput('nodes', JSON.stringify(builderInspect.nodes, undefined, 2));
        core.setOutput('endpoint', firstNode.endpoint); // TODO: deprecated, to be removed in a later version
        core.setOutput('status', firstNode.status); // TODO: deprecated, to be removed in a later version
        core.setOutput('flags', firstNode['buildkitd-flags']); // TODO: deprecated, to be removed in a later version
    }));
    if (!standalone && builderInspect.driver == 'docker-container') {
        stateHelper.setContainerName(`${buildx_1.Buildx.containerNamePrefix}${firstNode.name}`);
        yield core.group(`BuildKit version`, () => __awaiter(void 0, void 0, void 0, function* () {
            for (const node of builderInspect.nodes) {
                const buildkitVersion = yield toolkit.buildkit.getVersion(node);
                core.info(`${node.name}: ${buildkitVersion}`);
            }
        }));
    }
    if (core.isDebug() || ((_a = firstNode['buildkitd-flags']) === null || _a === void 0 ? void 0 : _a.includes('--debug'))) {
        stateHelper.setDebug('true');
    }
}), 
// post
() => __awaiter(void 0, void 0, void 0, function* () {
    if (stateHelper.IsDebug && stateHelper.containerName.length > 0) {
        yield core.group(`BuildKit container logs`, () => __awaiter(void 0, void 0, void 0, function* () {
            yield exec
                .getExecOutput('docker', ['logs', `${stateHelper.containerName}`], {
                ignoreReturnCode: true
            })
                .then(res => {
                if (res.stderr.length > 0 && res.exitCode != 0) {
                    core.warning(res.stderr.trim());
                }
            });
        }));
    }
    if (stateHelper.builderName.length > 0) {
        yield core.group(`Removing builder`, () => __awaiter(void 0, void 0, void 0, function* () {
            const buildx = new buildx_1.Buildx({ standalone: /true/i.test(stateHelper.standalone) });
            const rmCmd = yield buildx.getCommand(['rm', stateHelper.builderName]);
            yield exec
                .getExecOutput(rmCmd.command, rmCmd.args, {
                ignoreReturnCode: true
            })
                .then(res => {
                if (res.stderr.length > 0 && res.exitCode != 0) {
                    core.warning(res.stderr.trim());
                }
            });
        }));
    }
    if (stateHelper.certsDir.length > 0 && fs.existsSync(stateHelper.certsDir)) {
        yield core.group(`Cleaning up certificates`, () => __awaiter(void 0, void 0, void 0, function* () {
            fs.rmSync(stateHelper.certsDir, { recursive: true });
        }));
    }
}));
